module.exports = __webpack_public_path__ + "img/logo-scd-130x56.92b40af3.png";